import React, { useEffect, useState, useContext } from "react";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";
import { useHistory, useParams } from "react-router-dom";
import StateContext from "../StateContext";
import Axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import LoaderAnimation from "../Components/LoaderAnimation";
import { Link, NavLink } from "react-router-dom";
import ReviewModal from "../Components/reviewModal/reviewModal";
import { useTranslation, withTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    height: "100vh",
    alignItems: "center",
  },
}));
function PartialInvoice({ storeInfo, invoiceDetail, Amount, handleTryAgain }) {
  const {t} = useTranslation()
  const appState = useContext(StateContext);
  const history = useHistory();
  const { type, id } = useParams();
  const [paidDate, setPaidDate] = useState("sss");
  const [paidTime, setPaidTime] = useState("ddd");
  const [timeOut, setTimeOut] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const classes = useStyles();
  const [invoiceDetails, setInvoiceDetails] = useState(invoiceDetail);
  const [amount, setAmount] = useState(Amount);


  //destructure
  const { invoiceable } = invoiceDetails;
  // console.log(invoiceDetails)
  const comparePaidTime = () => {
    let currentTime = new Date();

    // let remainTime = currentTime - invoiceDetails.created_at;
    let splitDate = invoiceDetails.created_at.split("/");
    const day = splitDate[0]; // 15
    const month = splitDate[1]; // 04
    var year = splitDate[2]; // 2019
    const splitYear = year.split(" ");
    year = splitYear[0];
    const splitTime = splitYear[1].split(":");
    const hour = parseInt(splitTime[0]);
    const min = parseInt(splitTime[1]);
    let invoiceTime = new Date(year, month - 1, day);
    setPaidTime(`${splitYear[1]} ${splitYear[2]}`);
    setPaidDate(`${day}/${month}/${year}`);
    invoiceTime.setHours(hour);
    invoiceTime.setMinutes(min);
    // console.log(paidTime)
    let sub = currentTime - invoiceTime;
    // let sub = invoiceTime - currentTime

    var diffMins = Math.round(((sub % 86400000) % 3600000) / 60000);
    var diffHrs = Math.floor((sub % 86400000) / 3600000);
    // console.log(diffMins, 'mins')
    // console.log(diffHrs,'hours')
    // console.log(invoiceTime, 'invoiceTime')
    // console.log(currentTime,'currentTime')

    if (diffMins > 30 || diffHrs > 0) {
      setTimeOut(false);
    }
    setIsLoading(false);
    // console.log("timeeOOut",timeOut)
  };

  useEffect(() => {
    if (invoiceDetails !== null) {
      if (invoiceDetails.status == "Paid" || invoiceDetail.status == "Direct") {
        comparePaidTime();
      } else {
        setIsLoading(false);
      }
    } else {
      history.push("/");
    }
  }, []);

  const handleBackToStore = (e) => {
    e.preventDefault();
    history.push(
      `${process.env.REACT_APP_SHOP_URL + invoiceDetails.business.slug}`
    );
  };
  // if (isLoading) return <div className={classes.root}><CircularProgress /></div>
  if (isLoading)
    return (
      <div className={classes.root}>
        <LoaderAnimation />
      </div>
    );
  return (
    <>
    parital
      <ReviewModal storeInfo={storeInfo} invoiceDetail={invoiceDetail} />
      <div className="Invoice">
        {/* Logo */}
        <div className="text-center justify-content-center d-flex">
          <img
            src={invoiceDetails.business ? invoiceDetails.business.logo : ""}
            alt=""
            className="img-fluid"
            style={{ borderRadius: "20%", height: "100px", width: "100px" }}
          />
        </div>
        {/* Amount */}
        <div className="AmountContainer text-center mt-4">
          <p className="small text-muted m-0">Amount</p>
          {invoiceDetails.status == "Cancelled" ||
          invoiceDetails.status == "Failed" ? (
            <p className="redAmount">
              <strong>{invoiceDetail.amount} {t(`${storeInfo?.currency}`)}</strong>
            </p>
          ) : (
            <p className="amount">
              <strong>{invoiceDetail.amount} {t(`${storeInfo?.currency}`)}</strong>
            </p>
          )}

          {invoiceDetails.status === "Pending" ? (
            <>
              <div className="successIcon my-2 justify-content-center d-flex">
                {/* <CheckCircleRoundedIcon /> */}
                <div class="svg-box d-flex">
                  <svg class="circular yellow-stroke">
                    <circle
                      class="path"
                      cx="75"
                      cy="75"
                      r="50"
                      fill="none"
                      stroke-width="5"
                      stroke-miterlimit="10"
                    />
                  </svg>
                  <svg class="alert-sign yellow-stroke">
                    <g transform="matrix(1,0,0,1,-615.516,-257.346)">
                      <g transform="matrix(0.56541,-0.56541,0.56541,0.56541,93.7153,495.69)">
                        <path
                          class="line"
                          d="M634.087,300.805L673.361,261.53"
                          fill="none"
                        />
                      </g>
                      <g transform="matrix(2.27612,-2.46519e-32,0,2.27612,-792.339,-404.147)">
                        <circle
                          class="dot"
                          cx="621.52"
                          cy="316.126"
                          r="1.318"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
              <div className="paymentPaymentMessage">
                <h4>
                  <strong className="text-secondary mt-2">
                    Payment Pending
                  </strong>
                </h4>
              </div>
            </>
          ) : (
            ""
          )}

          {invoiceDetails.status === "Processing" ? (
            <>
              <div className="successIcon my-2 d-flex justify-content-center">
                {/* <CheckCircleRoundedIcon /> */}
                <div class="svg-box d-flex">
                  <svg class="circular yellow-stroke">
                    <circle
                      class="path"
                      cx="75"
                      cy="75"
                      r="50"
                      fill="none"
                      stroke-width="5"
                      stroke-miterlimit="10"
                    />
                  </svg>
                  <svg class="alert-sign yellow-stroke">
                    <g transform="matrix(1,0,0,1,-615.516,-257.346)">
                      <g transform="matrix(0.56541,-0.56541,0.56541,0.56541,93.7153,495.69)">
                        <path
                          class="line"
                          d="M634.087,300.805L673.361,261.53"
                          fill="none"
                        />
                      </g>
                      <g transform="matrix(2.27612,-2.46519e-32,0,2.27612,-792.339,-404.147)">
                        <circle
                          class="dot"
                          cx="621.52"
                          cy="316.126"
                          r="1.318"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                {/* <div class="svg-box">
                            <svg class="circular green-stroke">
                                <circle class="path" cx="75" cy="75" r="50" fill="none" stroke-width="5" stroke-miterlimit="10" />
                            </svg>
                            <svg class="checkmark green-stroke">
                                <g transform="matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-489.57,-205.679)">
                                    <path class="checkmark__check" fill="none" d="M616.306,283.025L634.087,300.805L673.361,261.53" />
                                </g>
                            </svg>
                        </div> */}
                {/* CheckMark Animation */}
                {/* <div class="svg-box">
                            <svg class="circular red-stroke">
                                <circle class="path" cx="75" cy="75" r="50" fill="none" stroke-width="5" stroke-miterlimit="10" />
                            </svg>
                            <svg class="cross red-stroke">
                                <g transform="matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-502.652,-204.518)">
                                    <path class="first-line" d="M634.087,300.805L673.361,261.53" fill="none" />
                                </g>
                                <g transform="matrix(-1.28587e-16,-0.79961,0.79961,-1.28587e-16,-204.752,543.031)">
                                    <path class="second-line" d="M634.087,300.805L673.361,261.53" />
                                </g>
                            </svg>
                        </div> */}
              </div>
              <div className="paymentPaymentMessage">
                <h4>
                  <strong className="text-secondary mt-2">
                    Payment Processing
                  </strong>
                </h4>
              </div>
            </>
          ) : (
            ""
          )}

          {invoiceDetails.status === "Paid" ||
          invoiceDetails.status === "Direct" ? (
            <>
              <div className="successIcon my-2 d-flex justify-content-center">
                {/* <CheckCircleRoundedIcon /> */}

                <div class="svg-box d-flex">
                  <svg class="circular green-stroke">
                    <circle
                      class="path"
                      cx="75"
                      cy="75"
                      r="50"
                      fill="none"
                      stroke-width="5"
                      stroke-miterlimit="10"
                    />
                  </svg>
                  <svg class="checkmark green-stroke">
                    <g transform="matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-489.57,-205.679)">
                      <path
                        class="checkmark__check"
                        fill="none"
                        d="M616.306,283.025L634.087,300.805L673.361,261.53"
                      />
                    </g>
                  </svg>
                </div>
              </div>
              <div className="paymentPaymentMessage">
                <h4>
                  <strong className=" mt-2" style={{ color: "green" }}>
                    Payment Paid
                  </strong>
                </h4>
              </div>
            </>
          ) : (
            ""
          )}

          {invoiceDetails.status === "Failed" ? (
            <>
              <div className="successIcon my-2  d-flex justify-content-center">
                {/* <CheckCircleRoundedIcon /> */}

                {/* CheckMark Animation */}
                <div
                  class="svg-box d-flex
                        "
                >
                  <svg class="circular red-stroke">
                    <circle
                      class="path"
                      cx="75"
                      cy="75"
                      r="50"
                      fill="none"
                      stroke-width="5"
                      stroke-miterlimit="10"
                    />
                  </svg>
                  <svg class="cross red-stroke">
                    <g transform="matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-502.652,-204.518)">
                      <path
                        class="first-line"
                        d="M634.087,300.805L673.361,261.53"
                        fill="none"
                      />
                    </g>
                    <g transform="matrix(-1.28587e-16,-0.79961,0.79961,-1.28587e-16,-204.752,543.031)">
                      <path
                        class="second-line"
                        d="M634.087,300.805L673.361,261.53"
                      />
                    </g>
                  </svg>
                </div>
              </div>
              <div className="paymentPaymentMessage">
                <h4>
                  <strong className="text-secondary mt-2">
                    Payment Failed
                  </strong>
                </h4>
              </div>
            </>
          ) : (
            ""
          )}



          {invoiceDetails.status === "Cancelled" ? (
            <>
              <div className="successIcon my-2  d-flex justify-content-center">
                {/* <CheckCircleRoundedIcon /> */}

                {/* CheckMark Animation */}
                <div class="svg-box d-flex">
                  <svg class="circular red-stroke">
                    <circle
                      class="path"
                      cx="75"
                      cy="75"
                      r="50"
                      fill="none"
                      stroke-width="5"
                      stroke-miterlimit="10"
                    />
                  </svg>
                  <svg class="cross red-stroke">
                    <g transform="matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-502.652,-204.518)">
                      <path
                        class="first-line"
                        d="M634.087,300.805L673.361,261.53"
                        fill="none"
                      />
                    </g>
                    <g transform="matrix(-1.28587e-16,-0.79961,0.79961,-1.28587e-16,-204.752,543.031)">
                      <path
                        class="second-line"
                        d="M634.087,300.805L673.361,261.53"
                      />
                    </g>
                  </svg>
                </div>
              </div>
              <div className="paymentPaymentMessage">
                <h4>
                  <strong className="text-secondary mt-2">
                    Payment Cancelled
                  </strong>
                </h4>
              </div>
            </>
          ) : (
            ""
          )}
 <>
      <p className="text-muted">Check Invoice Below</p>

      <div className="invoice_details">
        <div className="row m-0  justify-content-center">
       

          <div className="col-12">
            <div className="  px-1">
              <h6 classNAme="text-secondary mt-2 ">Invoice No</h6>
              <h6 className="text-muted"># {id} </h6>
            </div>
          </div>

          <div className="col-6">
            <ul
              className={`${
                appState.langValue === "ar"
                  ? "d-flex flex-column align-items-start"
                  : ""
              }`}
            >
              {/* Date */}
              {invoiceDetails.paid.date ? (
                <React.Fragment>
                  <li className="text-secondary mt-2">Date </li>
                  <li className="text-primary">
                    {invoiceDetails.paid.date}
                  </li>
                </React.Fragment>
              ) : (
                ""
              )}
              {invoiceDetails.transaction ? invoiceDetails.transaction.failed_at.date ? (
                <React.Fragment>
                  <li className="text-secondary mt-2">Date </li>
                  <li className="text-primary">
                    {invoiceDetails.transaction.failed_at.date}
                  </li>
                </React.Fragment>
              ) : (
                ""
              ) : ( "")}
              {/* Date */}
              {invoiceDetails.name && <>
                <li className="text-secondary mt-2">Customer</li>
              <li className="text-muted text-capitalize ">
                {invoiceDetails
                  ? invoiceDetails.name
                  : "unavailable"}
              </li>
              </>}
              {/* Customer */}
           

              {/* Customer */}
              {/* lOcation */}
              <li className="text-secondary mt-2">Store Location</li>
              <li className="text-muted">Kuwait</li>
              {/* lOcation */}

              {/* Payment Method */}
              <li className="text-secondary mt-2">Payment Method</li>
              <li className="text-muted">
                {invoiceDetails.transaction
                  ? invoiceDetails.transaction.payment_source
                  : (invoiceDetails?.is_partial ? "Split" : "")}
              </li>

           

              {/* Order type */}
            </ul>
          </div>
          
          <div className="col-6">
            <ul
              className={`${
                appState.langValue === "ar"
                  ? "d-flex flex-column align-items-start"
                  : ""
              }`}
            >
              {/* Time */}
              {invoiceDetails.paid.time ? (
                <React.Fragment>
                  <li className="text-secondary mt-2">Time </li>
                  <li className="text-primary">
                    {invoiceDetails.paid.time}
                  </li>
                </React.Fragment>
              ) : (
                ""
              )}

                {invoiceDetails.transaction ? invoiceDetails.transaction.failed_at.time ? (
                <React.Fragment>
                  <li className="text-secondary mt-2">Time </li>
                  <li className="text-primary">
                    {invoiceDetails.transaction.failed_at.time}
                  </li>
                </React.Fragment>
              ) : (
                ""
              ) : ("")}
              {/* Number */}
              { invoiceDetails.number ? (
                <>
                  <li className="text-secondary mt-2">Number</li>
                  <li className="text-muted">
                    { invoiceDetails.number
                      }
                  </li>
                </>
              ) : (
                ""
              )}
              {/* Number */}
              {/* lOcation */}

              {/* lOcation */}
              {invoiceDetails.business &&<>
              {/* Payment Method */}
              <li className="text-secondary mt-2">Store Name</li>
              <li className="text-muted">
               {invoiceDetails.business.name} 
              </li>
              </>}
              {/* Payment Method */}
              {/* Reference ID */}
              {/* <li className="text-secondary mt-2">Reference ID</li>
            <li className="text-muted">Dummy</li> */}
              {/* Reference ID */}
              {/* Table Number */}
                <>
                  {" "}
                  {invoiceDetails.transaction.source &&
                  <>
                  <li className="text-secondary mt-2">Soruce</li>
                  <li className="text-muted">
                    
                    {  invoiceDetails.transaction.source }
                  </li>
                  </>
                    }
                </>
              {/* Table Number */}
            </ul>
          </div>

         
        </div>

      
      </div>

      <div className="row py-5">
        <div
          className={`col-md-12 d-flex ${
            appState.loggedIn
              ? "justify-content-between"
              : "justify-content-center"
          } `}
        >
       
          {appState.loggedIn && (
            <div className="w-100 px-2">
              <Link to="/dashboard">
                <Button className=" bg-primary   w-100">
                  Dashboard
                </Button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </>
          
         
          {/* invoiceBtn */}
        </div>
      </div>
    </>
  );
}

export default withTranslation() (PartialInvoice);
